import Cookies from 'js-cookie'


const CookieApi = {


	cookieName: 	window.FxOnlineStore.store.cookie_name,
	cookieDomain: 	window.FxOnlineStore.store.cookie_domain,


	/**
	 * Retrieves custom user cookie
	 * 
	 * @return	{obj} 	Cookie data
	 */
	getUserCookie() {
		let cookie = Cookies.getJSON( this.cookieName )

		if( 'object' !== typeof cookie ) {
			cookie = {
				guest: 		false,
				location: 	null,
				name: 		'',
				ordertype: 	'',
				penn: 		false,
			}
		}

		return cookie
	},


	/**
	 * Sets custom user cookie
	 * 
	 * @param 	{obj} 	cookie 	Updated cookie data
	 * @return	{bool}	True, if successfully set cookie
	 */
	setUserCookie( cookie ) {
		if( 'object' !== typeof cookie ) {
			return false
		}

		// manually remove preexisting cookie (just to be safe)
		Cookies.remove( this.cookieName )

		// @todo — btoa cookiedata to make smaller?
		Cookies.set(
			this.cookieName,
			cookie, 
			{
				domain: 	this.cookieDomain,
				expires:	14,
				secure:		true,
			}
		)

		return true
	},


	/**
	 * Replace custom user cookie with guest-specific cookie
	 * 
	 * @return	{bool}	True, if successfully set cookie
	 */
	setGuestCookie() {
		const cookie = this.getUserCookie() 

		cookie.guest 		= true
		cookie.location 	= null
		cookie.name			= ''
		cookie.ordertype 	= 'pickup'
		cookie.penn 		= false

		return this.setUserCookie( cookie )
	},


	/**
	 * Remove guest status in user cookie
	 * 
	 * @return	{bool}	True, if successfully set cookie
	 */
	removeGuestCookie() {
		const cookie = this.getUserCookie()

		cookie.guest = false

		return this.setUserCookie( cookie )
	},


	/**
	 * Set cookie value
	 * 
	 * @param	{string}	[ key ]		Cookie key
	 * @param 	{mixed} 	[ value ]	Cookie value
	 * 
	 * @return	{bool}		True, if successfully set cookie
	 */
	setCookieValue( key = '', value = '' ) {
		const cookie = this.getUserCookie()

		if( 'string' === typeof key && key ) {
			cookie[ key ] = value

			return this.setUserCookie( cookie )
		}

		return false
	},

}


export default CookieApi